import { RegionLead, RegionLeadRef } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const assignRegionLead: (
  fetchContext: FetchContext,
  programId: number,
  regionId: number,
  regionLead: RegionLead,
  accessToken?: string,
) => Promise<RegionLeadRef> = (fetchContext, programId, regionId, regionLead, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/programs/${programId}/regions/${regionId}/leads`,
  {
    method: 'POST',
    body: JSON.stringify(regionLead),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<RegionLeadRef>(fetchContext.errorStore, response, 'assign region lead'));
